﻿const { css } = require("jquery");
const { head } = require("lodash");

window.strategyBrowser = function () {

    // area headings
    var areas = document.querySelectorAll('.strategy-browser__area');

    // expando headings
    var headings = document.querySelectorAll('.strategy-item__heading-container');

    // contents (for carousel controls)
    var contents = document.querySelectorAll('.strategy-item__content-container');

    var cssClass = "expanded";

    // contents -> create pager controls and attach events
    contents.forEach(function (ctrl, i) {

        // create previous and next pager controls...

        var prev = document.createElement('button');
        var next = document.createElement('button');

        prev.classList.add('strategy-browser__pager');
        prev.classList.add('pager--prev');

        next.classList.add('strategy-browser__pager');
        next.classList.add('pager--next');


        // attach click events...

        next.addEventListener('click', function () {

            var nextIndex = i + 1;

            if (nextIndex > headings.length -1)
                nextIndex = 0;

            goToSlide(nextIndex);
        });

        prev.addEventListener('click', function () {

            var nextIndex = i - 1;

            if (nextIndex < 0)
                nextIndex = headings.length - 1;

            goToSlide(nextIndex);
        })

        // append to document...

        ctrl.appendChild(prev);
        ctrl.appendChild(next);
    })

    // areas -> attach click event
    areas.forEach(function (area, i) {

        area.addEventListener('click', function () {
            if (i < headings.length) {
                goToSlide(i);
            }
        })
    })  

    // expando-headings -> attach click event
    headings.forEach(function (heading) {

        heading.addEventListener('click', function () {

            // find the parent item
            var parent = heading.parentElement;

            // toggle css class
            if (parent.classList.contains(cssClass)) {
                parent.classList.remove(cssClass);
            } else {
                parent.classList.add(cssClass);
            }

        })
    })

    function goToSlide(index) {

        if (index > headings.length && index > areas.length) {
            console.log('Paging index out of range at ' + index);
            return;
        }

        // find the current selected content
        var currentContent = document.querySelectorAll('.strategy-item.expanded');

        // find the current selected area
        var currentArea = document.querySelectorAll('.strategy-browser__area.expanded');

        currentContent.forEach(function (c) {
            c.classList.remove(cssClass);
        })

        currentArea.forEach(function (c) {
            c.classList.remove(cssClass);
        })

        // update the heading at the same index
        headings[index].parentElement.classList.add(cssClass);

        // update the area
        areas[index].classList.add(cssClass);
    }

}

if (document.readyState !== 'loading') {
    window.strategyBrowser();
} else {
    document.addEventListener('DOMContentLoaded', function () {
        window.strategyBrowser();
    });
}
